<template>
  <v-sheet
    :class="[
      'docs-hero-banner pa-5 mb-5',
      { 'docs-hero-banner--dark': inDarkMode },
    ]"
    rounded="lg"
  >
    <div
      v-if="eyebrow"
      class="caption text-uppercase font-weight-bold mb-2 docs-hero-eyebrow"
    >
      {{ eyebrow }}
    </div>

    <h1 class="headline font-weight-bold mb-2 docs-hero-title">
      {{ title }}
    </h1>

    <p class="body-1 mb-0 docs-hero-description">
      {{ description }}
    </p>

    <div
      v-if="metaItems.length"
      class="docs-hero-meta mt-4"
    >
      <v-chip
        v-for="item in metaItems"
        :key="item.label"
        small
        outlined
        :class="[
          'mr-2 mb-2 text-none docs-hero-chip',
          { 'docs-hero-chip--dark': inDarkMode },
        ]"
      >
        <font-awesome-icon
          v-if="item.icon"
          :icon="item.icon"
          size="sm"
          class="mr-2"
        />
        {{ item.label }}
      </v-chip>
    </div>

    <div
      v-if="$slots.actions"
      class="mt-4"
    >
      <slot name="actions" />
    </div>
  </v-sheet>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')

export default {
  name: 'DocsHeroBanner',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    eyebrow: {
      type: String,
      default: '',
    },
    metaItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapAuthGetters(['inDarkMode']),
  },
}
</script>

<style scoped lang="scss">
.docs-hero-banner {
  border: 1px solid rgba(0, 0, 0, 0.08);
  background:
    radial-gradient(circle at top right, rgba(0, 174, 214, 0.12), transparent 34%),
    linear-gradient(135deg, rgba(9, 44, 76, 0.04), rgba(255, 255, 255, 0.96));
}

.docs-hero-eyebrow {
  color: #055289;
  letter-spacing: 0.8px;
}

.docs-hero-title {
  color: #0d2f4b;
}

.docs-hero-description {
  color: rgba(13, 47, 75, 0.78);
  max-width: 720px;
}

.docs-hero-meta {
  display: flex;
  flex-wrap: wrap;
}

.docs-hero-banner--dark {
  border-color: rgba(149, 214, 255, 0.34);
  // Subtle gradient without overpowering the content, using brand colors with transparency.
  background:
    radial-gradient(circle at top right, rgba(0, 174, 214, -0.76), transparent 42%),
    linear-gradient(135deg, rgba(2, 20, 34, 0.94), rgba(7, 30, 49, 0.92));
}

.docs-hero-banner--dark .docs-hero-eyebrow {
  color: rgba(148, 222, 255, 0.94);
}

.docs-hero-banner--dark .docs-hero-title {
  color: #f1f8ff;
}

.docs-hero-banner--dark .docs-hero-description {
  color: rgba(235, 246, 255, 0.9);
}

.docs-hero-chip--dark {
  border-color: rgba(154, 220, 255, 0.48) !important;
  color: rgba(237, 247, 255, 0.95) !important;
}
</style>
